import React, { useContext } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import * as PATHS from './settings/paths';
import AuthContext from './context/Auth';

/* Pages  */
import { Error404, Contact, About, PrivacyPolicies, Terms } from './container/Static';
import { Login, Register, Verify, ResendCode, ResetPassword, ForgotPassword } from './container/Auth';
import { Profile, ChangePassword, Bookings } from './container/User';

import Home from './container/Home/Home';
import SearchResults from './container/SearchResults/SearchResults';
import Hotel from './container/Hotel/Hotel';
import { B2BLogin } from './container/B2B';
import Payment from './container/Payment';

const routes = [
  {
    path: PATHS.HOME,
    component: Home,
    exact: true,
  },
  {
    path: PATHS.SEARCH_RESULTS,
    component: SearchResults,
    exact: true,
  },
  {
    path: PATHS.HOTEL,
    component: Hotel,
    exact: true,
  },
  {
    path: PATHS.B2B_LOGIN,
    component: B2BLogin,
    exact: true,
  },
  {
    path: PATHS.LOGIN,
    component: Login,
    exact: true,
  },
  {
    path: PATHS.REGISTER,
    component: Register,
    exact: true,
  },
  {
    path: PATHS.VERIFY,
    component: Verify,
    exact: true,
  },
  {
    path: PATHS.RESEND_CODE,
    component: ResendCode,
    exact: true,
  },
  {
    path: PATHS.RESET_PASSWORD,
    component: ResetPassword,
    exact: true,
  },
  {
    path: PATHS.FORGOT_PASSWORD,
    component: ForgotPassword,
    exact: true,
  },
  {
    path: PATHS.CONTACT_US,
    component: Contact,
    exact: true,
  },
  {
    path: PATHS.ABOUT_US,
    component: About,
    exact: true,
  },
  {
    path: PATHS.PRIVACY_POLICIES,
    component: PrivacyPolicies,
    exact: true,
  },
  {
    path: PATHS.TERMS_AND_CONDITIONS,
    component: Terms,
    exact: true,
  },
];

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { state } = useContext(AuthContext);
  console.log(state.isLogged);
  return <Route render={(props) => (state.isLogged ? <Component {...props} /> : <Redirect to={Home} />)} {...rest} />;
};

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        {routes.map(({ path, component, exact = false }) => (
          <Route key={path} path={path} exact={exact} component={component} />
        ))}
        <ProtectedRoute path={PATHS.PROFILE} component={Profile} />
        <ProtectedRoute path={PATHS.CHANGE_PASSWORD} component={ChangePassword} />
        <ProtectedRoute path={PATHS.BOOKINGS} component={Bookings} />
        <ProtectedRoute path={PATHS.PAYMENT} component={Payment} />

        <Route component={Error404} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
